import { resolveConfig } from "./config";
import { renderFooter } from "./render";
import type { FooterConfig } from "./types";

async function boot(script?: HTMLScriptElement | null): Promise<void> {
  try {
    const config = await resolveConfig(script);
    renderFooter(config);
  } catch (error) {
    console.warn("[PandoriumFooter] Falha ao inicializar.", error);
  }
}

function scheduleBoot(): void {
  const script =
    document.currentScript instanceof HTMLScriptElement
      ? document.currentScript
      : document.querySelector('script[data-pandorium-footer]');

  void boot(script instanceof HTMLScriptElement ? script : null);
}

export const PandoriumFooter = {
  init(config?: Partial<FooterConfig>): Promise<boolean> {
    return resolveConfig().then((resolved) => {
      const merged = { ...resolved, ...config };
      return renderFooter(merged);
    });
  },
};

declare global {
  interface Window {
    PandoriumFooter?: typeof PandoriumFooter;
  }
}

if (typeof window !== "undefined") {
  window.PandoriumFooter = PandoriumFooter;

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", scheduleBoot);
  } else {
    scheduleBoot();
  }
}
